import { marked } from 'marked'
import mustache from 'mustache'

class Texts {
  all = {}
  language = null

  defaultLanguage = null // utilisé si pas de données avec le current language

  init(texts, language, defaultLanguage) {
    this.all = {}
    this.setLanguage(language)
    this.defaultLanguage = defaultLanguage


    texts.forEach(t => {
      if(t.id) {
        if(this.all[t.id] !== undefined) {
          window.alert("Careful, some texts have the same id (" + t.id + "), check your texts.data file")
        }

        this.all[t.id] = t
      }
    })
  }

  merge(texts) {
    texts.forEach(t => {
      if(t.id) {
        this.all[t.id] = t
      }
    })
  }

  /**
   *
   * @param {string} language l'id du langage tel qu'on peut le trouver dans les colonnes du .data
   */
  setLanguage(language) {
    this.language = language
  }



  /**
   * Permet de récupérer une chaine de caractères depuis le fichier .data à l'aide d'une id.
   * La chaine peut être traduite, contenir des variables placeholder, voire du markdown
   * @param {string} id l'id de la ligne dans le fichier .data
   * @param {object} options un objet contenant des options
   * @param {string} options.mustacheVars - Contient les variables de mustache
   * @param {boolean} options.parseMarkdown - Faut-il utiliser le Markdown ?
   * @param {object} options.markdownOptions - Les options du markdown (cf doc de Marked)
   * @param {object} options.language - Permet de forcer un langage spécialement pour cette requête
   * @param {object} options.fallback - Si pas trouvé, renvoie cela s'il existe

   * @returns {string} la chaine de caractères
   */
  get(id, options = {}) {
    options = { mustacheVars: null, parseMarkdown: false, markdownOptions: {}, ...options}

    let lang = options.language || this.language

    let t

    let row = this.all[id]
    if(row === undefined){
      if(options.fallback !== undefined) return options.fallback
      console.warn("The id", id, "doesn't exist in your .data file")

      // ici on n'a ni le texte dans la langue demandée, ni dans la langue par défaut...
      return id
    }


    if(row[lang]) {
      t = row[lang]
    }
    else {
      console.warn(`The id <${id}> doesn't exist in requested language (${this.language})`)
      if(this.defaultLanguage !== this.language && row[this.defaultLanguage]) { // on essaie le defaultlanguage
        t = row[this.defaultLanguage]
        console.warn(`Using ${this.defaultLanguage} for id <${id}>`)
      }
    }

    if(t !== undefined) {

      if(options.mustacheVars) {
        t = this.parseMustache(t, options.mustacheVars)
      }

      if(options.parseMarkdown) {
        t = this.parseMarkdown(t)
      }

      return t
    }

    if(options.fallback !== undefined) return options.fallback
      // en dernier recours...
    return id
  }

  /**
   *
   * @param {string} text Le texte à convertir
   * @param {Object} options Objet d'options
   * @param {boolean} options.noParagraph les blocs de text ne sont pas entourés de <p>
   * @returns {string} du html
   */
  parseMarkdown(text, options) {

    if(!text) return text
    let opts = { linkTargetBlank: true, ...options}
    const renderer = new marked.Renderer();
    if(opts.linkTargetBlank) {
      const linkRenderer = renderer.link;
      renderer.link = (href, title, text) => linkRenderer.call(renderer, href, title, text).replace(/^<a /, '<a target="_blank" rel="nofollow" ') }
    if(opts.noParagraph) { renderer.paragraph = text => text + '\n' }

    return marked(text, {renderer})
  }


  parseMustache(text, options) {
    return mustache.render(text, options)
  }

  removeMarkdown(markdown) {
    // Remplace les balises Markdown par une chaîne vide
    return markdown
        .replace(/([*_]{1,2}|~{1,2}|`{1,2}|!$$.*?$$$.*?$|$$(.*?)$$$.*?$|\n{2,})/g, ' ')
        .replace(/\s+/g, ' ') // Remplace les espaces multiples par un seul espace
        .trim(); // Supprime les espaces en début et fin de chaîne
  }


}


export default new Texts()